// extracted by mini-css-extract-plugin
export var subscribeForm = "SubscribeForm-module--subscribeForm--Fm1co";
export var subscribeDesc = "SubscribeForm-module--subscribeDesc--wCLe3";
export var footerListHeading = "SubscribeForm-module--footerListHeading--A-n-5";
export var footerListRow = "SubscribeForm-module--footerListRow--YBsrJ";